import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to top of page on route changes.
 * Handles both window scroll and custom scroll containers.
 * Works on mobile Safari/Chrome.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // Skip scroll reset if there's a hash (anchor link)
    if (hash) return;

    // Skip on history POP (Back button / hardware back) so the browser and
    // useScrollRestore can bring the user back to where they were in a list.
    if (navType === 'POP') return;

    // Use requestAnimationFrame to ensure DOM is painted before scroll
    requestAnimationFrame(() => {
      // Reset window scroll
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      
      // Fallback for Safari/iOS
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Reset any custom scroll containers
      const scrollContainers = [
        '.main-content',
        '.page-scroll',
        '.scroll-container',
        '[data-scroll-container]'
      ];

      scrollContainers.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
          el.scrollTop = 0;
        }
      });
    });
  }, [pathname, search, hash, navType]);

  return null;
}
